import Vue from 'vue'
import Vuex from 'vuex'
import { setHtmlLang } from '@/util/lang.js'

Vue.use(Vuex)

const localStoragePlugin = store => {
  // 当 store 初始化后调用
  store.subscribe((mutation, state) => {
    if (mutation.type === 'setLang') {
      window.localStorage.setItem('lang', state.lang)
      setHtmlLang(state.lang)
    }
  })
}

export default new Vuex.Store({
  state: {
    lang: 'en',
    langProducttype: {
      en: [],
      'zh-CN': []
    },
    // productTypes: [],
    currenttid: '',
    langNewtype: {
      en: [],
      'zh-CN': []
    },
    // newTypes: [],
    currentnewtid: '',
    currentabouttid: '',
    currentcontacttid: ''
  },
  mutations: {
    setLang (state, lang) {
      state.lang = lang
    },
    setLangProducttype (state, { lang, productstype }) {
      state.langProducttype[lang] = productstype
    },
    setCurrenttid (state, tid) {
      state.currenttid = tid
    },
    setLangNewtype (state, type) {
      state.langNewtype = type
    },
    setCurrentnewtid (state, tid) {
      state.currentnewtid = tid
    },
    setCurrentabouttid (state, tid) {
      state.currentabouttid = tid
    },
    setCurrentcontacttid (state, tid) {
      state.currentcontacttid = tid
    }
  },
  actions: {
    setLang ({ commit }, lang) {
      commit('setLang', lang)
    },
    setLangProducttype ({ commit }, { lang, productstype }) {
      commit('setLangProducttype', { lang, productstype })
    },
    setCurrenttid ({ commit }, tid) {
      commit('setCurrenttid', tid)
    },
    setCurrentnewtid ({ commit }, tid) {
      commit('setCurrentnewtid', tid)
    },
    setCurrentabouttid ({ commit }, tid) {
      commit('setCurrentabouttid', tid)
    },
    setCurrentcontacttid ({ commit }, tid) {
      commit('setCurrentcontacttid', tid)
    }
  },
  plugins: [localStoragePlugin]
})
